export default "__VITE_ASSET__06d58cd4__"